import { IFormatter } from '../interfaces';
import { DecimalFormatter } from '../decimal';

interface ICurrencyFormatOptions {
  currency?: string;
  decimalSeparator?: string;
  stripDecimals?: boolean;
}

const defaultOptions: ICurrencyFormatOptions = {
  currency: '€',
  decimalSeparator: ',',
  stripDecimals: false,
};

/**
 * A formatter for currency values.
 */
export class CurrencyFormatter implements IFormatter<ICurrencyFormatOptions> {

  format(input: string | number, options?: ICurrencyFormatOptions): string {

    const opts = {
      ...defaultOptions,
      ...options,
    };

    const decimalFormatter = new DecimalFormatter();
    const formatted = decimalFormatter.format(input, opts);

    if (!opts.currency) {
      return formatted;
    }

    return `${opts.currency} ${formatted}`;
  }
}